// File: AssessmentCategoryBox.js
import React from "react";
import ProfileCard from "./components/assessmentProfile/ProfileCard";
import CategoryHeader from "./components/assessmentProfile/CategoryHeader";

const AssessmentCategoryBox = ({ profiles, category, onDelete }) => {
  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <CategoryHeader category={category} profileCount={profiles.length} />
      <div className="border-t border-gray-200">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 p-3 md:p-4">
          {profiles.map((profile) => (
            <ProfileCard
              key={profile._id}
              profile={profile}
              onDelete={onDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssessmentCategoryBox;
